import React from 'react'
import RegisterStep1 from '../Components/Register/Register-first'

function Register() {
    return (
        <RegisterStep1 />
    )
}

export default Register
